<template>
    <section class="social-wall">
        <div class="wrapper">
            <div class="cta">
                <div>
                    <p>Choisissez par destinations</p>
                    <custom-select class="pin"
                                   :options="filteredDestinations"
                                   valueField="slug"
                                   labelField="name"
                                   v-model="destinationSelect"
                    ></custom-select>
                </div>
                <div class="btn" @click="addPhoto()">Ajouter ma photo <span class="icon-picto-add-photo"></span></div>
            </div>

            <div class="thumbs-list clearfix">
                <transition-group
                        appear
                        name="fade"
                        tag="ul"
                        v-bind:css="false"
                        v-on:before-enter="beforeEnter"
                        v-on:enter="enter"
                >
                    <li v-for="(item, index) in filteredItems"
                        :key="index"
                        v-if="showArticle(index)"
                        :data-index="index"
                        @click="showDetail(index)"


                    >
                        <a href="" @click.prevent><img :src="item.thumbUrl" alt=""></a>
                    </li>
                </transition-group>
                <template v-if="filteredItems.length === 0 && !loader">
                    <br>
                    <p>Pas de photos pour le moment</p>
                    <br>
                </template>
                <div class="loader-spin" v-if="loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

            </div>
            <a class="btn chevron dir-down loadmore"
               v-if="!reachEnd"
               @click="showMore()"
            >Voir plus</a>

        </div>


        <social-wall-detail :items="filteredItems" :clickedIndex="clickedIndex"></social-wall-detail>
        <social-wall-add-photo ref="socialwalladdphoto" :destinations="destinations"
                               :url-background="urlBackground"></social-wall-add-photo>

    </section>
</template>

<script>
    import $ from 'jquery';
    import Modal from '../../libs/Modal';
    import {debounce} from 'lodash';
    import Vue from 'vue';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            destinations: {
                type: Array,
                required: true,
            },
            urlBackground: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                filteredItems: [],
                filteredDestinations: null,
                ShowLimit: null,
                defautShowLimit: 16,
                showMoreCount: 8,
                offset: null,
                destinationSelect: 'all',
                loader: false,
                clickedIndex: 0,

            };
        },
        watch: {
            destinationSelect() {
                this.changeFilter();
            },
        },
        computed: {
            reachEnd() {
                if (this.filteredItems.length === this.ShowLimit || this.filteredItems.length < this.ShowLimit) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        methods: {
            initFilter() {
                this.filteredDestinations = Vue.util.extend([], this.destinations);
                this.filteredDestinations.unshift({
                    name: 'Toutes les destinations',
                    slug: 'all',
                });
            },
            showArticle(index) {
                if (index < this.ShowLimit) {
                    return true;
                }
            },
            showMore() {

                setTimeout(() => {
                    this.offset = this.offset + this.showMoreCount;
                }, 100);

                this.ShowLimit = this.ShowLimit + this.showMoreCount;
            },
            changeFilter() {
                this.loader = true;
                this.filteredItems = [];
                this.ShowLimit = this.defautShowLimit;
                this.offset = 0;
                this.setOffset();

                setTimeout(() => {
                    this.loader = false;

                    this.filteredItems = this.items.filter((photo) => {
                        if (this.destinationSelect === 'all') {
                            return photo;
                        } else {
                            return photo.destinationSlug === this.destinationSelect;
                        }
                    });


                }, 300);
            },
            beforeEnter: function (el) {
                $(el).removeClass('show');
                $(el).addClass('hidden');
            },
            enter: function (el, done) {
                var delay = ((el.dataset.index - this.offset) * 150);
                setTimeout(() => {
                    $(el).addClass('show');
                }, delay);

            },
            showDetail(index) {
                this.clickedIndex = index;
                Modal.showModal('#social-wall-detail');

            },
            addPhoto() {
                if (window.GrandsEspaces.user) {
                    // Logged
                    Modal.showModal('#social-wall-add-photo');


                } else {
                    this.$parent.$refs['login-panel'].issocialwall = true;
                    // Not Logged
                    Modal.showModal('#loginpanel');
                }

            },
            setOffset: debounce(function () {
                this.offset = this.defautShowLimit;
            }, 2000),
        },
        created() {
            this.filteredItems = this.items;
            this.offset = 0;
            this.ShowLimit = this.defautShowLimit;
            this.initFilter();
        },
        mounted() {
            this.setOffset();
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/social-wall/SocialWall.vue